import React from 'react'
import { MobXProviderContext } from 'mobx-react'

export default function useStores() {
  const rootStore = React.useContext(MobXProviderContext)
  return rootStore
}
